export default __webpack_public_path__ + "static/media/detail_big_1_2.d7a37bbb.png";